import type { AttachmentTypeUnion, ProviderType } from 'owa-graph-schema';
import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import type ReferenceAttachmentType from 'owa-service/lib/contract/ReferenceAttachment';
import { REFERENCE_ATTACHMENT_TYPE } from 'owa-attachment-constants/lib/attachmentTypes';
import { convertProviderTypeToGQL } from './attachmentProviderType';

export const convertAttachmentToGql = (
    serviceAttachment: AttachmentType | ReferenceAttachmentType
): AttachmentTypeUnion => {
    if (!serviceAttachment || !serviceAttachment.__type) {
        return serviceAttachment as AttachmentTypeUnion;
    }

    switch (serviceAttachment.__type) {
        case REFERENCE_ATTACHMENT_TYPE: {
            // OneDrivePro is a special case where the providerType is not in calem case, as seen here:
            // https://o365exchange.visualstudio.com/O365%20Core/_git/Substrate?path=/sources/dev/services/src/OData/Model/Schema/ReferenceAttachmentSchema.cs&version=GBmaster&_a=contents&line=158&lineStyle=plain&lineEnd=163&lineStartColumn=1&lineEndColumn=10
            const referenceAttachment = serviceAttachment as ReferenceAttachmentType;
            referenceAttachment.ProviderType = convertProviderTypeToGQL(
                referenceAttachment.ProviderType
            );
            return {
                ...(referenceAttachment as typeof serviceAttachment & {
                    ProviderType: ProviderType;
                    AttachmentThumbnailUrl: string;
                    AttachmentPreviewUrl: string;
                }),
                OwsTypeName: serviceAttachment.__type,
                __typename: 'ReferenceAttachment',
            };
        }
        default: {
            return {
                ...serviceAttachment,
                OwsTypeName: serviceAttachment.__type,
                __typename: 'BasicAttachment',
            };
        }
    }
};
